import React, { useEffect, useState } from "react";
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react'

export default function Pagination(props) {
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    setCurrentPage(props.currentPage + 1);
    setTotalPages(props.totalPages);
  }, [props])

  return (
    <>
      {totalPages > 1 && (
        <div className="d-flex justify-content-end align-items-center mt-5 mb-3 me-2 gap-3">
          {
            currentPage > 1 &&
            (<div className="link" onClick={() => props.pagination("previous")}>
              <IconArrowLeft stroke={3} className="ms-1" />Prev Page
            </div>)
          }
          {currentPage}
          {
            (totalPages - currentPage) > 0 &&
            (<div className="link" onClick={() => props.pagination("next")}>Next Page<IconArrowRight stroke={3} className="ms-1" />
            </div>)
          }
        </div>
      )}
    </>
  );
}
